
































import {defineComponent, PropType, ref} from "@vue/composition-api";
import AuthLayout from "@tool/Layouts/AuthLayout.vue";
import {TeamInvitationEntityInterface} from "@tool/tool.types";
import {WithProps} from "@base/base.types";
import useAxios from "@tool/Helpers/useAxios";
import useSwal from "@tool/Helpers/useSwal";
import {useInertia} from "@tool/Helpers/useInertia";
import useFormHelper from "@tool/Helpers/useFormHelper";
import FormError from "@tool/Components/FormError.vue";

export default defineComponent({
    components: {
        AuthLayout,
        FormError
    },
    props: {
        team_invitation: {
            type: Object as PropType<WithProps<TeamInvitationEntityInterface, 'invited_by_user' | 'team'> | null>,
            required: false
        },
        authenticated: {
            type: Boolean,
            required: true
        }
    },
    setup(props) {

        const mode = ref<'register' | 'login' | null>(null);

        const form = useFormHelper({});

        const acceptInvitation = async () => {
            if(!props.team_invitation || !props.authenticated) {
                useSwal().fire({
                    text: 'Could not accept invitation at this moment. Please try again later.',
                    icon: 'error',
                });
                return;
            }

            const response = await form.value.submit(() => {
                return useAxios().post<{ success: true; }>(route('team-invitation.accept', {
                    team_invitation_id: props.team_invitation!.id
                }));
            });

            if(response.success) {
                useInertia().get(route('app.team.projects.index', props.team_invitation!.team_id), {}, {
                    onFinish() {
                        useSwal().fire({
                            title: 'Invitation Accepted!',
                            text: 'You successfully accepted the invitation to join the team!',
                            icon: 'success'
                        })
                    }
                })
            }

        }


        return {
            mode,
            form,
            acceptInvitation,
        }
    }
})
